/**
 * MVP-NAV — derives from firm-navigation-catalog.ts (single source of truth).
 */
import type { LucideIcon } from "lucide-react";
import {
  getCatalogSlot,
  getDesktopRailSlots as catalogDesktopRail,
  getMobileBottomSlots as catalogMobileBottom,
  isCatalogPrimaryPath,
  MOBILE_BOTTOM_SLOT_IDS,
  DESKTOP_RAIL_SLOT_IDS as CATALOG_DESKTOP_RAIL_IDS,
  NAV_CATALOG_SLOTS,
} from "./firm-navigation-catalog";

export type FirmPrimaryNavSlot = {
  id: string;
  word: string;
  to: string;
  search?: Record<string, unknown>;
  icon: LucideIcon;
  match: (pathname: string) => boolean;
};

function toPrimarySlot(slot: ReturnType<typeof getCatalogSlot>): FirmPrimaryNavSlot {
  return {
    id: slot.id,
    word: slot.word,
    to: slot.to,
    search: slot.search,
    icon: slot.icon,
    match: slot.match,
  };
}

export const FIRM_PRIMARY_NAV: readonly FirmPrimaryNavSlot[] = Object.values(NAV_CATALOG_SLOTS).map(
  toPrimarySlot,
);

export const MOBILE_BOTTOM_NAV_SLOT_IDS = MOBILE_BOTTOM_SLOT_IDS;
export const DESKTOP_RAIL_SLOT_IDS = CATALOG_DESKTOP_RAIL_IDS;

export function getMobileBottomNavSlots(): readonly FirmPrimaryNavSlot[] {
  return catalogMobileBottom().map(toPrimarySlot);
}

export function getDesktopRailSlots(): readonly FirmPrimaryNavSlot[] {
  return catalogDesktopRail().map(toPrimarySlot);
}

export function isFirmPrimaryPath(pathname: string): boolean {
  return isCatalogPrimaryPath(pathname);
}

export { PRIMARY_SLOT_IDS, OVERFLOW_CATEGORIES } from "./firm-navigation-catalog";
